export type PREVIOUS_PAGE_IDENTIFIER = (typeof PREVIOUS_PAGE_IDENTIFIER)[keyof typeof PREVIOUS_PAGE_IDENTIFIER];
export const PREVIOUS_PAGE_IDENTIFIER = {
  /** チェックイン検索 */
  CHECKIN_SEARCH: 'checkinSearch',
  /** チェックイン状況詳細 */
  CHECKIN_STATUS: 'checkinStatus',
  /** チェックイン対象選択 */
  CHECKIN_SELECT: 'checkinSelect',
  /** チェックイン搭乗者情報入力 */
  CHECKIN_PASSENGER_INPUT: 'checkinPassengerInput',
  /** チェックイン確認 */
  CHECKIN_REVIEW: 'checkinReview',
  /** チェックインシートマップ */
  CHECKIN_SEATMAP: 'checkinSeatmap',
  /** 予約詳細 */
  SERVICING_MY_BOOKING: 'myBooking',
  /** チェックイン完了 */
  CHECKIN_COMPLETED: 'checkinCompleted',
} as const;
